import axios, { AxiosError } from 'axios';

const BASE_URL = '/api';

export const apiClient = axios.create({
  baseURL: BASE_URL,
  timeout: 30_000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Special long-running client for AI-heavy endpoints (character creation)
export const apiClientLong = axios.create({
  baseURL: BASE_URL,
  timeout: 120_000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export class ApiException extends Error {
  status: number;
  detail: string;
  constructor(detail: string, status: number) {
    super(detail);
    this.detail = detail;
    this.status = status;
    this.name = 'ApiException';
  }
}

function toApiException(error: unknown): ApiException {
  if (error instanceof AxiosError) {
    const status = error.response?.status ?? 0;
    const data = error.response?.data as { detail?: string } | undefined;
    const detail = data?.detail ?? error.message ?? 'Network error';
    return new ApiException(detail, status);
  }
  if (error instanceof Error) {
    return new ApiException(error.message, 0);
  }
  return new ApiException('Unknown error', 0);
}

apiClient.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(toApiException(error)),
);
apiClientLong.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(toApiException(error)),
);

export function imageUrl(filenameOrUrl: string | null | undefined): string | undefined {
  if (!filenameOrUrl) return undefined;
  if (filenameOrUrl.startsWith('http://') || filenameOrUrl.startsWith('https://')) {
    return filenameOrUrl;
  }
  if (filenameOrUrl.startsWith('/api/')) return filenameOrUrl;
  if (filenameOrUrl.startsWith('/')) return filenameOrUrl;
  return `/api/image/${filenameOrUrl}`;
}

export const worldMapImageUrl = (bust?: number | string) =>
  `/api/worldmap${bust !== undefined ? `?v=${bust}` : ''}`;
